import './AvailableEntries.scss';
import { _ } from '../../Lang.class.js';
import './scrollbar.scss';
import type {Entry} from "./types";
import {Entries} from "./Entries";

type AvailableEntriesCallbacks = {
    onClickEntry: (entry: Entry) => void,
}

export class AvailableEntries extends Entries {

    private readonly root: HTMLDivElement;
    private readonly callbacks: AvailableEntriesCallbacks;

    constructor(root: HTMLDivElement, callbacks: AvailableEntriesCallbacks) {
        super();
        this.root = root;
        this.callbacks = callbacks;
        this.render();
    }

    private render(): void {
        this.root.innerHTML = this.getHTML();
    }

    public populate(entries: Entry[]): void {
        super.populate(entries);
        this.redraw();
    }

    public redraw(): void {
        const entriesList = this.root.querySelector('.available-entries-list');
        entriesList.innerHTML = '';
        this.entries.forEach(entry => {
            const entryElement = document.createElement('div');
            entryElement.classList.add('entry');
            entryElement.dataset.id = entry.id.toString();
            entryElement.innerHTML = _(entry.name);
            entriesList.appendChild(entryElement);

            // on click entry
            entryElement.addEventListener('click', () => {
              this.callbacks.onClickEntry(entry);
            });
        });
    }

    public filter(searchString: string): void {
        const entries = this.root.querySelectorAll('.entry');
        entries.forEach(entry => {
            if (searchString !== '' && entry.innerHTML.toLowerCase().indexOf(searchString.toLowerCase()) === -1) {
                entry.classList.add('hidden');
            } else {
                entry.classList.remove('hidden');
            }
        });
    }

    private getHTML(): string {
        return `
            <div class="available-entries-list"></div>
        `;
    }

}
